export default __webpack_public_path__ + "static/media/EricStage400.bd97b8b0.jpg";